import React from 'react';
import PropTypes from 'prop-types';

import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';
import SkeletonHitCard from 'Components/Card/HitCard/SkeletonHitCard';

/**
 * A product listing page for page skeletons: the title and description from StaticSearch, then
 * Components/ProductListing as it first renders, with the filters panel closed (filter button and result count on
 * the left, results per page and sort on the right, then the product grid).
 *
 * Its SCSS also has the parts other listing skeletons share: `SkeletonListing__title` (an h1),
 * `SkeletonListing__heading` (a section h2) and `SkeletonListing__grid` (a CSS grid of SkeletonHitCards, two columns
 * until the page adds more).
 */
export default function SkeletonListing({ blurb, cards }) {
  return (
    <div className="SkeletonListing">
      <div className="container">
        <SkeletonBlock className="SkeletonListing__title" />
        {blurb &&
          <SkeletonBlock className="SkeletonListing__blurb" />
        }
      </div>

      <section className="container SkeletonListing__content">
        <div className="SkeletonListing__controls">
          <div className="SkeletonListing__group">
            <SkeletonBlock className="SkeletonListing__button SkeletonListing__button--filter" />
            <SkeletonBlock className="SkeletonListing__count d-none d-lg-block" />
          </div>
          <div className="SkeletonListing__group">
            <SkeletonBlock className="SkeletonListing__button d-none d-lg-block" />
            <SkeletonBlock className="SkeletonListing__button" />
          </div>
        </div>

        <div className="SkeletonListing__grid SkeletonListing__grid--listing">
          <SkeletonHitCard numberOfCards={cards} xsSize={12} smSize={12} mdSize={12} lgSize={12} />
        </div>
      </section>
    </div>
  );
}

SkeletonListing.propTypes = {
  blurb: PropTypes.bool,
  cards: PropTypes.number,
};

SkeletonListing.defaultProps = {
  blurb: true,
  cards: 12,
};
